import { useAuth0 } from "@auth0/auth0-react";
import { useForm } from "features/form/fabric";
import { z } from "zod";


export const useAuth = () => {
	const auth0 = useAuth0();

	const form = useForm({
		defaultValues: {
			email: ""
		},
		validators: {
			onSubmit: z.object({
				email: z.email()
			})
		},
		onSubmit: ({ value }) => {
			auth0.loginWithRedirect({ authorizationParams: { login_hint: value.email, prompt: "login" } });
		}
	});
	return { ...auth0, form };
};